import './index.scss';
// import logo from '../../../logo.svg';
import React from 'react'

const ProjectDiv = ({text, link, logo, index}) => {
  return (
    <a href={link} className={`project-link _${index}`} key={0} target="_blank" rel="noreferrer">
      <img src={logo} alt="Todos App" loading="lazy" />
      <p>
        <b>{text}</b>
      </p>
    </a>
  )
}

export default ProjectDiv
